<template>
    <Modal :mask-closable="false" draggable @on-close="reset()" class="demo-drawer-prime"
            :title="$parent.userData?'Edit User':'Add User'" v-model="$parent.addUserDrawer" width="450">

        <Form :model="userForm" :rules="ruleUserForm" label-position="top" ref="userForm">
            <Row :gutter="10">
                <Col span="24">
                    <FormItem prop="name" label="Name">
                        <Input v-model="userForm.name"></Input>
                    </FormItem>
                </Col>
                <Col span="24" v-show="!$parent.userData">
                    <FormItem prop="password" label="Password">
                        <Input type="password" v-model="userForm.password"></Input>
                    </FormItem>
                </Col>
                <Col span="15">
                    <FormItem  prop="mobile" label="Mobile Number">
                        <Input :maxlength="10" number v-model="userForm.mobile"></Input>
                    </FormItem>
                </Col>
                <Col span="9" style="text-align: center">
                  <FormItem prop="isActive" label="Status">
                    <i-switch v-model="userForm.isActive" :style="userForm.isActive?'background: green':'background: red'"/>
                  </FormItem>
                </Col>
                <Col span="24">
                    <FormItem  prop="email" label="Email">
                        <Input v-model="userForm.email"></Input>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem prop="role" label="Select Role">
                        <Select v-model="userForm.role">
                            <Option v-for="role in $parent.rolesArr" :value="role.id" :label="role.name" :key="role.id">
                                <div class="ivu-select-item-div"> {{role.name}}</div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24" v-show="userForm.role === constants.cityManagerRoleId">
                         <FormItem prop="cityArr" label="Select Cities">
                                    <Select v-model="userForm.cityArr" :remote-method="remoteMethodCity"
                                            multiple filterable remote>
                                      <Option v-for="(cityObj,index) in territories" :label="cityObj.city"
                                              :key="index" :value="cityObj.city">
                                         <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                      </Option>
                                    </Select>
                          </FormItem>
                </Col>
            </Row>
        </Form>
        <div slot="footer">
            <Button v-show="!editMode" @click="addUser" type="primary" :loading="loading">
                <span v-if="!loading">ADD</span>
                <span v-else>Loading...</span>
            </Button>
            <Button v-show="editMode" @click="modifyUser" type="primary">Update</Button>
            <Button style="background: #999999; color: white;font-weight: bolder" @click="reset();$parent.addUserDrawer=false">CANCEL</Button>
        </div>

    </Modal>
</template>

<script>
import {Constants, generateUUID} from "../Constants/Constant";
import {ADD_USER, ADD_USERCITIES, UPDATE_USER} from '../graphql/mutations/users'
import { SEARCH_CITY2 } from '../graphql/queries/territories'
import md5 from 'js-md5'
import checkDuplication from '../mixins/checkDuplication'
import ValidationRules from "../Constants/ValidationRules";
    export default {
        apollo: {
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.territories = data.city;
                    }
                }
            }
        },
        name: "AddUserDrawer",
        mixins: [checkDuplication],
        data: function(){
            return{
                mutation_ADD_USER: ADD_USER,
                mutation_UPDATE_USER: UPDATE_USER,
                mutation_ADD_USERCITIES: ADD_USERCITIES,
                constants: Constants,
                userForm:{
                    name: '',
                    mobile:'',
                    email: '',
                    role: '',
                    password: '',
                    cityArr: [],
                    isActive: true
                },
                existingMobile: '',
                ruleUserForm: {
                    name: [{required: true, message: 'Please enter Name', trigger: 'change'}],
                    mobile: ValidationRules.mobile,
                    email: [{required: true, message: 'Please enter Email', trigger: 'change'},
                        {type: 'email', message: 'Invalid Email', trigger: 'change'}],
                    role: [{required: true, message: 'Please select Role', trigger: 'change'}],
                    password: [{ required: true, message: 'Please fill in the password.', trigger: 'change' },
                        { type: 'string', min: 6, message: 'The password length cannot be less than 6 bits', trigger: 'change' }],
                    cityArr: [{validator: this.validateCityArr, trigger: 'change'}]
                },
                cityFilter: '%%',
                territories: [],
                editMode: false,
                loading: false
            }
        },
        watch: {
            '$parent.addUserDrawer': function(val){
                if(val && this.$parent.userData){
                    this.setUserForm(this.$parent.userData);
                    this.editMode = true;
                }else{
                    this.ruleUserForm.password[0].required = true;
                    this.editMode = false;
                }
            }
        },
        methods: {
            validateCityArr(rule, value, callback){
                if(!value && this.userForm.role === this.constants.cityManagerRoleId){
                    callback(new Error('Please select City'))
                }else {
                    callback()
                }
            },
            remoteMethodCity: function(query){
                this.cityFilter = '%' + query + '%'
            },
            reset: function(){
                this.$refs['userForm'].resetFields();
                this.existingMobile = ''                  //Reset value
            },
            setUserForm(userData){
                this.userForm.name = userData.name;
                this.userForm.mobile = this.existingMobile = userData.mobile;
                this.userForm.email = userData.email;
                this.userForm.role = userData.role;
                this.userForm.isActive = userData.isActive;
                this.ruleUserForm.password[0].required = false;
                this.userForm.cityArr = userData.userCities.map(c => c.city);
            },
            async checkMobileExist(){
              if(this.userForm.mobile === this.existingMobile) return;
              let condition = { mobile: { _eq: this.userForm.mobile }}
              if(await this.checkDuplication('users', condition)){
                this.$Message.error('Mobile \''+this.userForm.mobile+'\' already exists !')
                this.loading = false
                return true
              }
            },
            addUser(){
                this.loading = true;
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {
                       this.insertUser();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertUser(){
                let self = this;
                if(await this.checkMobileExist()) return

                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_USER,
                    variables: {
                        id: generateUUID(),
                        name: this.userForm.name,
                        mobile: this.userForm.mobile,
                        email: this.userForm.email,
                        role: this.userForm.role,
                        isActive: this.userForm.isActive,
                        password: md5(this.userForm.password),
                        plainPassword: this.userForm.password
                    }
                })
                if(response.data.insert_users.returning[0].id){
                    if(this.userForm.role === this.constants.cityManagerRoleId){
                        this.userForm.cityArr.forEach(function(curnt){
                            self.insertUserCities(response.data.insert_users.returning[0].id, curnt);
                        })
                    }
                    this.$Message.success('New User added successfully!');
                    this.reset();
                    this.loading = false
                    this.$parent.addUserDrawer = false;
                }
            },
            async insertUserCities(userId, city){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_USERCITIES,
                    variables: {
                        userId: userId,
                        city: city
                    }
                })
                if(response.data){}
            },
            modifyUser(){
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {
                        this.updateUser();
                    }
                })
            },
            async updateUser(){
                let self = this;
                this.loading = true;
                if(await this.checkMobileExist()) return

                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_USER,
                    variables: {
                        userId: this.$parent.userData.id,
                        name: this.userForm.name,
                        mobile: this.userForm.mobile,
                        email: this.userForm.email,
                        role: this.userForm.role,
                        isActive: this.userForm.isActive
                     /* password: this.userForm.password ? md5(this.userForm.password) : this.$parent.userData.password */
                    }
                })
                if(response.data){
                    if(this.userForm.role === this.constants.cityManagerRoleId){
                        this.userForm.cityArr.forEach(function(curnt){
                            self.insertUserCities(self.$parent.userData.id, curnt);
                        })
                    }
                    this.$Message.success('User updated successfully!');
                    this.loading = false;
                    this.reset();
                    this.$parent.addUserDrawer = false;
                }
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
   /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
</style>
